import { render, staticRenderFns } from "./m-footer.vue?vue&type=template&id=11f791cc&scoped=true"
import script from "./m-footer.vue?vue&type=script&lang=js"
export * from "./m-footer.vue?vue&type=script&lang=js"
import style0 from "./m-footer.vue?vue&type=style&index=0&id=11f791cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f791cc",
  null
  
)

export default component.exports